import styles from './StatusBadge.module.css';

type BadgeVariant = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

interface StatusBadgeProps {
  label: string;
  variant?: BadgeVariant;
}

const STATUS_MAP: Record<string, BadgeVariant> = {
  published: 'success',
  confirmed: 'success',
  paid: 'success',
  active: 'success',
  pending: 'warning',
  waitlisted: 'warning',
  draft: 'neutral',
  cancelled: 'danger',
  refunded: 'danger',
  completed: 'info',
  waived: 'info',
};

export function StatusBadge({ label, variant }: StatusBadgeProps) {
  const resolvedVariant = variant ?? STATUS_MAP[label.toLowerCase()] ?? 'neutral';
  return (
    <span className={[styles.badge, styles[resolvedVariant]].join(' ')}>
      {label}
    </span>
  );
}
